import React, { Component } from "react";
import { Button, Modal, ModalHeader } from "reactstrap";
import apiInstance from "../common/api.js";
import { connect } from "react-redux";
import { updatePreviewPage } from "../actions";
import Axios from "axios";
import config from "../config";
import { formDigCode } from "../common/formDigCode";

class Datasheet extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
      modalText: ""
    };
    this.handleQuotationClick = this.handleQuotationClick.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.handleSendToClick = this.handleSendToClick.bind(this);
    this.handleRevisitClick = this.handleRevisitClick.bind(this);
    this.handleCloseClick = this.handleCloseClick.bind(this);
  }

  createMarkup(previewHtml) {
    return { __html: previewHtml };
  }

  handleSendToClick() {
    window.open(this.props.pdfLink);
    apiInstance.post("/sendTo", this.props.userDetails).then(res => {
      console.log("Successfully sent the email");
    });
  }

  handleRevisitClick() {
    this.props.onGettingResponse(null);
  }

  handleCloseClick() {
    window.location = "http://www.rotzler.com/en/";
  }

  handleQuotationClick() {
    var orderCode =
      "3.TI." +
      this.props.winchType.orderCode +
      "." +
      this.props.drumWidth.orderCode +
      "." +
      this.props.drumSurface.orderCode +
      "." +
      this.props.motorType.orderCode +
      "." +
      this.props.rotationDirection.orderCode +
      "." +
      this.props.motorLayout.orderCode +
      "." +
      (this.props.ropeEndControl.orderCode !== "00"
        ? this.props.ropeEndControl.orderCode
        : this.props.pressureRoller.orderCode) +
      "." +
      this.props.loadMeasuring.orderCode +
      "." +
      this.props.paintFinish.orderCode +
      "." +
      this.props.wireRope.orderCode +
      "." +
      formDigCode(this.props) +
      ".";
    //   "." +
    //   this.props.fasteners.orderCode +
    //  this.props.externalBrakeRelease.orderCode +
    //  this.props.throttleValve.orderCode +
    // ".";
    var data = {
      orderCode: orderCode,
      userId: this.props.userId,
      productId: this.props.productId
    };
    apiInstance.post("/emailShooter", data).then(res => {
      if (res.status === 200) {
        this.setState({
          show: true,
          modalText:
            "Thank you for submitting your request for quotation. We will present you the quote asap."
        });
      }
    });
  }

  closeModal() {
    this.setState({
      show: false
    });
  }

  render() {
    return (
      <div>
        <div
          dangerouslySetInnerHTML={this.createMarkup(this.props.previewHtml)}
        />
        <div className="btn-wrapper">
          <Button className="btn" onClick={this.handleSendToClick}>
            Generate PDF
          </Button>
          <Button className="btn" onClick={this.handleQuotationClick}>
            Request for quotation
          </Button>
          <Button className="btn" onClick={this.handleRevisitClick}>
            Revisit configuration
          </Button>
          <Button className="btn" onClick={this.handleCloseClick}>
            Close configurator
          </Button>
          {this.state.show && (
            <ModalContent
              toggle={this.closeModal}
              text={this.state.modalText}
            />
          )}
        </div>
      </div>
    );
  }
}

const mapActionToProps = {
  onGettingResponse: updatePreviewPage
};

const mapStateToProps = state => {
  return {
    winchType: state.winchType,
    mType: state.mType,
    drumWidth: state.drumWidth,
    drumSurface: state.drumSurface,
    motorType: state.motorType,
    rotationDirection: state.rotationDirection,
    motorLayout: state.motorLayout,
    pressureRoller: state.pressureRoller,
    ropeEndControl: state.ropeEndControl,
    loadMeasuring: state.loadMeasuring,
    paintFinish: state.paintFinish,
    wireRope: state.wireRope,
    fasteners: state.fasteners,
    externalBrakeRelease: state.externalBrakeRelease,
    throttleValve: state.throttleValve,
    pdfLink: state.pdfLink,
    orderCode: state.orderCode,
    userId: state.userId,
    productId: state.productId,
    userDetails: state.userDetails
  };
};

class ModalContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: true
    };

    this.toggle = this.toggle.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleRestart = this.handleRestart.bind(this);
  }

  handleClose() {
    window.location.href = "http://www.rotzler.com/en/";
  }

  handleRestart() {
    window.location.reload();
  }

  toggle() {
    this.setState({
      modal: !this.state.modal
    });
    if (this.state.modal) {
      this.props.toggle();
    }
  }

  render() {
    return (
      <Modal isOpen={this.state.modal} toggle={this.toggle}>
        <ModalHeader toggle={this.toggle}>{this.props.text}</ModalHeader>
        {/* <ModalBody>
          <Button className="btn" onClick={this.handleRestart}>
            Restart configuration
          </Button>
          <Button className="btn" onClick={this.handleClose}>
            Close configuration
          </Button>
        </ModalBody> */}
      </Modal>
    );
  }
}

export default connect(
  mapStateToProps,
  mapActionToProps
)(Datasheet);



// WEBPACK FOOTER //
// ./src/components/dataSheet.js